import { useEffect, useState } from "react";
import {
  Col,
  Card,
  CardBody,
  Container,
  Row,
  FormGroup,
  Label,
} from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import DataTable from "react-data-table-component";
import Datanotfound from "../../PageNotFound/Datanotfound";
import { decryptData } from "../../../utils/helper/Crypto";
import { format } from "date-fns";
import { useSweetAlert } from "../../../Context/SweetAlertContext";
import { WithdrawTitle, WithdrawHistory } from "../../../utils/Constant";
import { IoSearchSharp } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useCommonService } from "../../../Service/CommonService/Commonservice";
import CustomPagination from "../../CustomPagination";

const WithdrawReport = () => {
  const { showAlert } = useSweetAlert();
  const { ApiCalling } = useCommonService();

  // 🔹 States
  const [data, setData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [memberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );

  const [fromDate, setFromDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  });
  const [toDate, setToDate] = useState(new Date());

  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
const[Status,setStatus]=useState("All")
  // 🔹 Fetcher
  const FetchData = async (
    page = currentPage,
    size = perPage,
    search = filterText
  ) => {
    setLoading(true);

    const obj = {
      ClientId: memberID,
      FromDate: format(fromDate, "dd-MMMM-yyyy"),
      ToDate: format(toDate, "dd-MMMM-yyyy"),
      Status: Status,
      ActionMode: "Search",
      page: page, // ✅ lowercase keys
      size: size,
      search: search,
    };

    const param = {
      procName: "WithdrawFund",
      Para: JSON.stringify(obj),
    };

    console.log("📤 Payload sent:", param);

    try {
      const res = await ApiCalling(param);

      if (Array.isArray(res) && res.length > 0) {
        const cleanedData = res.map(({ TotalCount, ...rest }) => rest);

        // 🔹 Generate dynamic columns
        const keys = Object.keys(cleanedData[0]);
        const list = keys.map((col) => ({
          name: col,
          selector: (row: any) => row[col],
          sortable: true,
          wrap: true,
          cell: (row: any) => (
            <div dangerouslySetInnerHTML={{ __html: row[col] }} />
          ),
        }));

        setColumns(list);
        setData(cleanedData);
        setTotalRows(res[0]?.TotalCount ?? 0);
      } else {
        setColumns([]);
        setData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("❌ Withdraw Report fetch error:", error);
      showAlert("Something went wrong while fetching Withdraw Report");
    }

    setLoading(false);
  };

  // 🔹 Filter Submit
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setCurrentPage(1);
    FetchData(1, perPage, filterText);
  };

  // 🔹 Initial + pagination/search changes
useEffect(() => {
  FetchData(currentPage, perPage, filterText);
}, [currentPage, perPage, filterText]);

  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={WithdrawHistory}
        parent={WithdrawTitle}
        ChildName={WithdrawHistory}
      />

      <Container fluid className="innerPageCard">
        {/* 🔹 Filter Form */}
        <form onSubmit={handleSubmit}>
          <Row>
            <Col xl="12">
              <Row>
                <Col md="3">
                  <FormGroup>
                    <Label>From Date:</Label>
                    <DatePicker
                      className="form-control"
                      selected={fromDate}
                      onChange={(date: any) => setFromDate(date)}
                      dateFormat="dd-MMMM-yyyy"
                    />
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>To Date:</Label>
                    <DatePicker
                      className="form-control"
                      selected={toDate}
                      onChange={(date: any) => setToDate(date)}
                      dateFormat="dd-MMMM-yyyy"
                    />
                  </FormGroup>
                </Col>
           <Col md="3">
                  <FormGroup>
                    <Label>Status</Label>
                    <select value={Status} onChange={(e)=>setStatus(e.target.value)}
                      className="form-control" >
                      <option value="All">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Approved">Approved</option>
                      <option value="Rejected">Rejected</option>
                      </select>
                  </FormGroup>
                </Col>
                <Col
                  md="3"
                  className="d-flex align-items-center justify-content-start pb-2 pb-md-0"
                >
                  <button
                    type="submit"
                    className="btn btn-primary mt-0 mt-md-3"
                  >
                    <IoSearchSharp /> Search
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </form>

        {/* 🔹 Table */}
        <Col className="mb-3">
          <Card>
            <CardBody>
              <DataTable
                data={data}
                columns={columns}
                pagination={false}
                highlightOnHover
                progressPending={loading}
                noDataComponent={<Datanotfound />}
                subHeader
                subHeaderComponent={
                  <Row className="p-0 m-0 align-items-center justify-content-between ">
                    <Col
                      md={12}
                      className="d-flex align-items-center position-relative"
                    >
                      <IoSearchSharp
                        className="position-absolute"
                        style={{
                          top: "50%",
                          left: "30px",
                          fontSize: "20px",
                          transform: "translateY(-50%)",
                          color: "#999",
                          pointerEvents: "none",
                        }}
                      />
                      <input
                              className="form-control w-100 ps-5"
                              placeholder="Search value..."
                              value={filterText}
                              onChange={(e) => {
                                debugger
                                setFilterText(e.target.value);
                                setCurrentPage(1);
                                //FetchData(1, perPage, e.target.value);
                              }}
                            />
                    </Col>
                  </Row>
                }
              />

              {/* 🔹 Pagination */}
              {data.length > 0 || filterText !== "" ? (
                <CustomPagination
                  currentPage={currentPage}
                  perPage={perPage}
                  totalRows={totalRows}
                  onPageChange={(page: number) => setCurrentPage(page)}
                  onRowsPerPageChange={(newPerPage: number) => {
                    setPerPage(newPerPage);
                    setCurrentPage(1);
                  }}
                />
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  );
};

export default WithdrawReport;
